import { COLORS, Col, FlexView, Row } from '@cuemath/comps';
import React from 'react';
import styled from 'styled-components';
import { Text, TextInput } from '@cuemath/web-comps';

const DateWrapper = styled(Col)`
  border: 1px solid ${COLORS.GRAY_LIGHT};
  background: ${({ isSelected }) => isSelected && COLORS.BLACK};
  border-radius: 4px;
  cursor: pointer;
`;
const AvailableDatesWrapper = styled(FlexView)`
  padding-left: 24px;
`;
const DateSelector = styled(FlexView)`
  max-height: 44px;
  min-width: 250px;
`;

const AvailableDates = ({
  dateOptions,
  selectedDate,
  handleSelectDate,
  customDate,
  handleSelectCustomDate,
}) => {
  const renderDate = ({ id, dayOfWeek, formattedDate }) => {
    const isSelected = selectedDate === id;
    return (
      <Col gutter={12} onClick={() => handleSelectDate(id)} key={id}>
        <DateWrapper key={id} gutter={24} gap={8} isSelected={isSelected}>
          <Text
            variant="h6"
            align="center"
            style={{ fontSize: 16 }}
            color={isSelected ? 'white' : 'black'}
          >
            {formattedDate}
          </Text>
          <Text variant="eyebrow1" align="center" color={isSelected ? 'white' : 'black'}>
            {dayOfWeek}
          </Text>
        </DateWrapper>
      </Col>
    );
  };

  return (
    <AvailableDatesWrapper
      alignItems="center"
      flexDirection="row"
      justifyContent="space-between"
    >
      <Row>
        {dateOptions?.map(({ id, dayOfWeek, formattedDate }) =>
          renderDate?.({ id, dayOfWeek, formattedDate }),
        )}
      </Row>
      <DateSelector>
        <TextInput
          type="date"
          label="Select custom date"
          value={customDate?.value}
          onChange={value => handleSelectCustomDate(value)}
        />
      </DateSelector>
    </AvailableDatesWrapper>
  );
};

export default AvailableDates;
